import { useState, useEffect, useMemo } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import rou from '../../../../router';
import Header from '../RosterPlanner/head';
import { i18n } from '../../../../language';
import { dutyAssignAPI } from '../../../../apis';
import { C } from '../TemplateEdit/constant';
import Card from './card';
import Create from './create';

const useStyles = makeStyles((theme) => ({
  root: {},
  head: {
    padding: '5.938rem 0 1.938rem 3.438rem',
    backgroundColor: theme.palette.font.white,
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '2.25rem',
    color: '#001d63',
    fontWeight: 'bold',
    marginBottom: '0.3125rem',
  },
  smallTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
  },
  body: {
    padding: '1.875rem 0 0 3.438rem',
    backgroundColor: '#eef2f9',
    minHeight: '41.475rem',
  },
  context: {
    display: 'flex',
    flexWrap: 'wrap',
    '&>div': {
      marginRight: '1.25rem',
      marginBottom: '1.25rem',
    },
    '&>div:last-child': {
      marginRight: '0',
    },
  },
}));

function Template({ history, rouList }) {
  const classes = useStyles();
  const [templateList, setTemplateList] = useState(null);
  const [flag, setFlag] = useState(null);

  // getTemplateAPI
  const getMyTemplateAPI = async () => {
    try {
      const { result } = await dutyAssignAPI.getMyTemplate({pack:0});
      setTemplateList([...result]);
    } catch (error) {
      console.log('-----Get Template error----->', error);
    }
  };

  useEffect(() => {
    (async () => {
      await getMyTemplateAPI();
    })();
  }, [rouList]);

  const list = useMemo(() => {
    let template = [];

    if (Array.isArray(templateList) && templateList.length > 0) {
      template = _.map(templateList, (item) => {
        return {
          title: item.templateName,
          id: item.dutyTemplateWardId,
          [C.isDeleted]: item[C.isDeleted],
        };
      });
    }

    return template;
  }, [templateList]);

  const handleOnClick = () => {
    history.push(rou.TemplateEditRou.path);
    return null;
  };

  const handleEdit = (id) => {
    history.push(`${rou.TemplateEditRou.path}?id=${id}`);
    return null;
  };

  return (
    <div className={classes.root}>
      <Header path={rou.PlannerRou.path} text={i18n.t('DUTYASSIGN_BACK')} id="DutyAssign-Template-back" />
      <div className={classes.head}>
        <div className={classes.title}>{i18n.t('DUTYASSIGN_MYTEMPLATE_TITLE')}</div>
        <div className={classes.smallTitle}>{i18n.t('DUTYASSIGN_MYTEMPLATE_SUBTITLE')}</div>
      </div>
      <div className={classes.body}>
        <div className={classes.smallTitle} style={{ marginBottom: '1.875rem' }}>
          {i18n.t('DUTYASSIGN_MYTEMPLATE_BODY_TITLE')}
        </div>
        <div className={classes.context}>
          {list.map((card, index) => {
            return card.isDeleted !== 1 ? (
              <Card
                id={card.id}
                flag={flag}
                setFlag={setFlag}
                title={card.title}
                index={index}
                Click={() => handleEdit(card.id)}
                key={card.id}
              />
            ) : null;
          })}
          <Create Click={handleOnClick} id="DutyAssign-Create-afu" text={i18n.t('DUTYASSIGN_MYTEMPLATE_BODY_CREATE')} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  rouList: state.rouList,
});

export default connect(mapStateToProps)(Template);
